import { CorePayrollCategory } from '../payroll/payroll-enums';
import { User } from './User';

export interface UserOvertime {
  user: User;
  overtimes: Overtime[];
}

export enum RangeTypeValues {
  CurrentMonth = 'current_month',
  PreviousTwoMonths = 'previous_two_months',
  PreviousThreeMonths = 'previous_three_months',
  Yearly = 'yearly',
}

export interface UserOvertimeMap {
  user: User;
  overtimes: Map<RangeTypeValues, Overtime>;
}

export interface Overtime {
  userId: string;
  timeRange: Interval;
  overtimeInMinutes: number;
  overtimeCompensationInMinutes: number;
  overtTimeByPayrollCategoryNames: Record<string, number>;
}

export enum OvertimesToSum {
  OvertimeInMinutes = 'overtimeInMinutes',
  OvertimeCompensationInMinutes = 'overtimeCompensationInMinutes',
  RestOfOvertimes = 'restOfOvertimes',
}

export type OvertimeSummary = {
  [OvertimesToSum.OvertimeInMinutes]?: number;
  [OvertimesToSum.OvertimeCompensationInMinutes]?: number;
  [OvertimesToSum.RestOfOvertimes]?: (CorePayrollCategory & {
    value: number;
  })[];
};

export interface OvertimeRangeConfig {
  timeRange: Interval;
  fields: OvertimesToSum[];
}

export enum OvertimeTimeRangeKeys {
  SelectedMonth = 'selectedMonth',
  SelectedYear = 'selectedYear',
}

export enum PayrollCategoryNames {
  LeisureTimeAccount = 'leisure-time-account',
}

/** @deprecated use `Interval` from `"date-fns"` instead. */
export interface IntervalDate {
  start: Date | string;
  end: Date | string;
}
